/**
 * CaseChallenge section
 */
(function referencesFrontend($) {
    $(document).on('cms.ready', ready);

    let $section;

    const observerOptions = {
        root: null, // relative to document viewport
        rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: .5 // visible amount of item shown in relation to root
    };


    function ready() {
        $section = $('.sectionCaseChallenge');

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                // console.log(entry);
                if(entry.isIntersecting) {
                    // console.log(entry.target);
                    $(entry.target).addClass('fadeInUp');
                }
                else {
                    $(entry.target).removeClass('fadeInUp');
                }
            });
        }, observerOptions);

        $('.case-challenge__image', $section).each((idx, elm) => observer.observe(elm));
    }

})(jQuery, window);